let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("4BU1l")).then(() => parcelRequire('fTIZQ'));